// extracted by mini-css-extract-plugin
module.exports = {"star_ratings":"star-ratings_star_ratings__lg3Zh","star_ratings_large":"star-ratings_star_ratings_large__9y8eT"};